import DefaultImage from '../../assets/rebranding/feedback/empty-spaces/default.png';
import { formatImageUrl } from '../../utils/format';

interface GetFirstImageProps {
  id: number;
}

export function getFirstImage(images: GetFirstImageProps[] | []): string {
  if (!images?.length) {
    return DefaultImage;
  }

  return formatImageUrl(images[0].id);
}
